import { NavItem, ParentNavItem } from '../types'

export const isParentNavItem = (
  item: NavItem | ParentNavItem,
): item is ParentNavItem => {
  return 'navItems' in item
}
